import { groupBy } from '../object-utils';
import { format, FORMATS } from '../date-time/cmx-date-time';

type ActivityFormatter = (
  activity: CMxAPI.UserActivity | CMxAPI.SystemActivity | CQA.ActivityEntry | CMxAPI.UserActivityComment | CQA.CQAComment
) => string;

const superBasicActivityFormatter = (activity: CMxAPI.UserActivity) =>
  `${activity.username} ${activity.actionType} ${activity.code}`;

export const convertActivityToTimeline = (
  activity: (CMxAPI.UserActivity | CMxAPI.SystemActivity | CQA.ActivityEntry | CMxAPI.UserActivityComment | CQA.CQAComment)[],
  activityFormattersMap: Record<string, ActivityFormatter> = {}
): CMxCommonApp.TimelineItem[] => {
  // convert to a localized day so that we can group items
  const pregrouped = activity?.map(activity => {
    const day = format(activity.timestamp, FORMATS.DATE);
    return { ...activity, day };
  });
  // group items
  const grouped = groupBy(pregrouped, 'day');
  // get a sorted list of days
  const days = Object.keys(grouped).sort().reverse();
  // working by day, format all the items into
  // a timeline item
  const timelineItems = days?.map(day => {
    const groupedItems = grouped[day];
    const titles = groupedItems?.map(item => {
      const formatter = activityFormattersMap[item?.activityType];
      return formatter
        ? formatter(item)
        : superBasicActivityFormatter(item as CMxAPI.UserActivity);
    });

    const item: CMxCommonApp.TimelineItem = {
      key: day,
      tiles: [
        {
          subtitle: format(groupedItems[0].timestamp, FORMATS.LONG_DATE),
          titles
        }
      ]
    };
    return item;
  });

  return timelineItems;
};
